import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LayoutPublic from '../Layout/LayoutPublic';

import PropertyCalculator from '../../Features/PropertyCalculator/Components/PropertyCalculator';
import { InstallPWA } from '../../Features/InstallPWA/InstallPWA';


const RouterPublic = () => (
    <React.Fragment>
        <LayoutPublic />
        <main role="main" className="container">
            <Switch>
                <Route exact path="/" component={PropertyCalculator} />
                <Route exact path="/install" component={InstallPWA} />
            </Switch>
        </main>
    </React.Fragment>

);

export default RouterPublic;



// WEBPACK FOOTER //
// ./src/components/App/RouterPublic.jsx